<template>
  <div class="main-container">
    <navbar></navbar>
    <main-part></main-part>
    <footer-part></footer-part>
  </div>
</template>

<script>
  import Navbar from './components/Navbar.vue';
  import Footer from './components/Footer.vue';
  import Main from './components/Main.vue';
  
  export default {
    components: {
      'navbar' : Navbar,
      'main-part' : Main,
      'footer-part' : Footer
    }
  }
</script>


// WEBPACK FOOTER //
// src/App.vue